function productDefaults(ss304,ss316,ss321,bronze,monel,carbon,copper){
	this.ss304 = ss304;
	this.ss316 = ss316;
	this.ss321 = ss321;
	this.bronze = bronze;
	this.monel = monel;
	this.carbon = carbon;
	this.copper = copper;
}

var braidSpecs = [];
braidSpecs[0] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[1] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[2] = new productDefaults(3,2,3,3,3,3,3);
braidSpecs[3] = new productDefaults(1,1,1,3,1,3,3);
braidSpecs[4] = new productDefaults(3,2,3,3,2,3,3);
braidSpecs[5] = new productDefaults(1,1,1,3,1,3,3);
braidSpecs[6] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[7] = new productDefaults(1,1,1,1,1,3,1);
braidSpecs[8] = new productDefaults(2,2,2,2,1,3,2);
braidSpecs[9] = new productDefaults(1,1,1,1,1,2,1);
braidSpecs[10] = new productDefaults(1,1,1,1,2,2,1);
braidSpecs[11] = new productDefaults(3,2,3,3,2,3,3);
braidSpecs[12] = new productDefaults(3,2,3,3,2,3,3);
braidSpecs[13] = new productDefaults(1,1,1,1,1,3,1);
braidSpecs[14] = new productDefaults(1,1,1,2,2,1,2);
braidSpecs[15] = new productDefaults(2,1,2,3,2,2,3);
braidSpecs[16] = new productDefaults(1,1,1,1,1,2,1);
braidSpecs[17] = new productDefaults(3,3,3,3,3,3,3);
braidSpecs[18] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[19] = new productDefaults(3,3,3,3,1,3,3);
braidSpecs[20] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[21] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[22] = new productDefaults(1,1,1,1,3,2,1);
braidSpecs[23] = new productDefaults(2,1,2,3,3,3,3);
braidSpecs[24] = new productDefaults(2,1,2,3,1,3,3);
braidSpecs[25] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[26] = new productDefaults(3,1,3,2,3,3,2);
braidSpecs[27] = new productDefaults(2,1,2,3,3,3,3);
braidSpecs[28] = new productDefaults(3,3,3,3,3,3,3);
braidSpecs[29] = new productDefaults(3,3,3,3,3,3,3);
braidSpecs[30] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[31] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[32] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[33] = new productDefaults(1,1,1,2,3,3,2);
braidSpecs[34] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[35] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[36] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[37] = new productDefaults(1,1,1,1,2,2,1);
braidSpecs[38] = new productDefaults(1,1,1,2,2,3,2);
braidSpecs[39] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[40] = new productDefaults(1,1,1,2,2,3,2);
braidSpecs[41] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[42] = new productDefaults(2,1,2,3,2,3,2);
braidSpecs[43] = new productDefaults(3,2,3,3,2,3,3);
braidSpecs[44] = new productDefaults(2,1,2,2,2,3,2);
braidSpecs[45] = new productDefaults(3,2,3,3,2,3,3);
braidSpecs[46] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[47] = new productDefaults(1,1,1,2,1,2,2);
braidSpecs[48] = new productDefaults(1,1,1,2,1,3,2);
braidSpecs[49] = new productDefaults(3,2,3,2,1,3,2);
braidSpecs[50] = new productDefaults(1,1,1,2,1,3,2);
braidSpecs[51] = new productDefaults(3,2,3,2,1,3,2);
braidSpecs[52] = new productDefaults(1,1,1,1,1,3,1);
braidSpecs[53] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[54] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[55] = new productDefaults(1,1,1,3,3,1,3);
braidSpecs[56] = new productDefaults(1,1,1,1,1,3,1);
braidSpecs[57] = new productDefaults(3,2,3,1,1,3,1);
braidSpecs[58] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[59] = new productDefaults(1,1,1,1,1,2,2);
braidSpecs[60] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[61] = new productDefaults(1,1,1,3,1,1,3);
braidSpecs[62] = new productDefaults(1,1,1,3,1,1,3);
braidSpecs[63] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[64] = new productDefaults(1,1,1,1,1,1,1);
braidSpecs[65] = new productDefaults(1,1,1,3,1,3,3);
braidSpecs[66] = new productDefaults(3,3,3,3,2,3,3);
braidSpecs[67] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[68] = new productDefaults(1,1,1,1,1,1,1);
braidSpecs[69] = new productDefaults(1,1,1,3,1,3,3);
braidSpecs[70] = new productDefaults(1,1,1,3,1,3,3);
braidSpecs[71] = new productDefaults(2,1,2,3,1,3,3);
braidSpecs[72] = new productDefaults(1,1,1,3,1,3,3);
braidSpecs[73] = new productDefaults(2,1,2,3,1,3,3);
braidSpecs[74] = new productDefaults(1,1,1,2,2,3,2);
braidSpecs[75] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[76] = new productDefaults(3,2,3,3,2,3,3);
braidSpecs[77] = new productDefaults(1,1,1,1,1,1,1);
braidSpecs[78] = new productDefaults(3,3,3,3,3,3,3);
braidSpecs[79] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[80] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[81] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[82] = new productDefaults(1,1,1,3,3,1,3);
braidSpecs[83] = new productDefaults(1,1,1,3,1,2,3);
braidSpecs[84] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[85] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[86] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[87] = new productDefaults(1,1,1,3,3,2,3);
braidSpecs[88] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[89] = new productDefaults(1,1,1,3,2,2,3);
braidSpecs[90] = new productDefaults(1,1,1,3,3,2,3);
braidSpecs[91] = new productDefaults(1,1,1,3,3,2,3);
braidSpecs[92] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[93] = new productDefaults(1,1,1,3,3,2,3);
braidSpecs[94] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[95] = new productDefaults(1,1,1,3,2,3,3);
braidSpecs[96] = new productDefaults(2,1,2,3,2,3,3);
braidSpecs[97] = new productDefaults(1,1,1,3,3,3,3);
braidSpecs[98] = new productDefaults(1,1,1,1,1,2,1);
braidSpecs[99] = new productDefaults(1,1,1,2,2,3,2);
braidSpecs[100]= new productDefaults(1,1,1,3,2,2,3);
braidSpecs[101]= new productDefaults(1,1,1,3,2,1,3);
braidSpecs[102]= new productDefaults(1,1,1,1,1,3,1);
braidSpecs[103]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[104]= new productDefaults(1,1,1,2,2,3,2);
braidSpecs[105]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[106]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[107]= new productDefaults(1,1,1,1,2,3,1);
braidSpecs[108]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[109]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[110]= new productDefaults(1,1,1,1,3,1,1);
braidSpecs[111]= new productDefaults(1,1,1,1,1,1,1);
braidSpecs[112]= new productDefaults(1,1,1,1,1,3,1);
braidSpecs[113]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[114]= new productDefaults(1,1,1,2,2,3,2);
braidSpecs[115]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[116]= new productDefaults(1,1,1,3,1,1,3);
braidSpecs[117]= new productDefaults(1,1,1,3,2,2,3);
braidSpecs[118]= new productDefaults(2,1,2,2,3,3,2);
braidSpecs[119]= new productDefaults(2,1,2,2,3,3,2);
braidSpecs[120]= new productDefaults(1,1,1,1,1,3,1);
braidSpecs[121]= new productDefaults(1,1,1,1,2,3,1);
braidSpecs[122]= new productDefaults(1,1,1,2,3,3,2);
braidSpecs[123]= new productDefaults(1,1,1,1,3,3,3);
braidSpecs[124]= new productDefaults(1,1,1,1,1,1,3);
braidSpecs[125]= new productDefaults(1,1,1,3,1,2,3);
braidSpecs[126]= new productDefaults(1,1,1,2,2,2,1);
braidSpecs[127]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[128]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[129]= new productDefaults(3,3,3,2,2,3,2);
braidSpecs[130]= new productDefaults(1,1,1,3,1,3,3);
braidSpecs[131]= new productDefaults(3,3,3,2,2,3,2);
braidSpecs[132]= new productDefaults(1,1,1,2,2,2,2);
braidSpecs[133]= new productDefaults(3,3,3,2,2,2,2);
braidSpecs[134]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[135]= new productDefaults(1,1,1,1,1,1,1);
braidSpecs[136]= new productDefaults(1,1,1,1,1,1,1);
braidSpecs[137]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[138]= new productDefaults(3,2,3,3,3,3,3);
braidSpecs[139]= new productDefaults(1,1,1,3,3,2,3);
braidSpecs[140]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[141]= new productDefaults(1,1,1,2,1,2,2);
braidSpecs[142]= new productDefaults(1,1,1,1,2,3,2);
braidSpecs[143]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[144]= new productDefaults(2,1,2,2,3,3,3);
braidSpecs[145]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[146]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[147]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[148]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[149]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[150]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[151]= new productDefaults(1,1,1,2,3,3,2);
braidSpecs[152]= new productDefaults(1,1,1,2,3,3,2);
braidSpecs[153]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[154]= new productDefaults(1,1,1,2,2,2,2);
braidSpecs[155]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[156]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[157]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[158]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[159]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[160]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[161]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[162]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[163]= new productDefaults(1,1,1,1,1,1,1);
braidSpecs[164]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[165]= new productDefaults(1,1,1,2,1,2,2);
braidSpecs[166]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[167]= new productDefaults(3,3,3,2,2,3,2);
braidSpecs[168]= new productDefaults(3,3,3,3,1,3,3);
braidSpecs[169]= new productDefaults(1,1,1,2,1,3,3);
braidSpecs[170]= new productDefaults(1,1,1,2,1,3,3);
braidSpecs[171]= new productDefaults(1,1,1,2,1,3,3);
braidSpecs[172]= new productDefaults(2,1,2,2,1,3,3);
braidSpecs[173]= new productDefaults(1,1,1,3,3,2,3);
braidSpecs[174]= new productDefaults(2,1,2,1,1,3,1);
braidSpecs[175]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[176]= new productDefaults(3,3,3,2,2,3,3);
braidSpecs[177]= new productDefaults(1,1,1,2,1,2,3);
braidSpecs[178]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[179]= new productDefaults(1,1,1,1,2,2,1);
braidSpecs[180]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[181]= new productDefaults(1,1,1,2,2,2,2);
braidSpecs[182]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[183]= new productDefaults(1,1,1,2,1,2,2);
braidSpecs[184]= new productDefaults(1,1,1,2,1,2,2);
braidSpecs[185]= new productDefaults(1,1,1,3,1,3,3);
braidSpecs[186]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[187]= new productDefaults(1,1,1,1,1,3,3);
braidSpecs[188]= new productDefaults(2,1,2,3,2,3,3);
braidSpecs[189]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[190]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[191]= new productDefaults(2,2,2,3,3,3,3);
braidSpecs[192]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[193]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[194]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[195]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[196]= new productDefaults(1,1,1,1,1,3,1);
braidSpecs[197]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[198]= new productDefaults(1,1,1,2,1,3,2);
braidSpecs[199]= new productDefaults(1,1,1,2,1,3,2);
braidSpecs[200]= new productDefaults(1,1,1,2,2,2,2);
braidSpecs[201]= new productDefaults(1,1,1,1,2,3,1);
braidSpecs[202]= new productDefaults(1,1,1,1,2,3,2);
braidSpecs[203]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[204]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[205]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[206]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[207]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[208]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[209]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[210]= new productDefaults(3,1,3,3,2,3,3);
braidSpecs[211]= new productDefaults(3,2,3,3,2,3,3);
braidSpecs[212]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[213]= new productDefaults(3,3,3,3,2,3,3);
braidSpecs[214]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[215]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[216]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[217]= new productDefaults(3,3,3,2,2,3,3);
braidSpecs[218]= new productDefaults(3,3,3,2,1,3,3);
braidSpecs[219]= new productDefaults(1,1,1,1,1,3,1);
braidSpecs[220]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[221]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[222]= new productDefaults(1,1,1,3,2,2,3);
braidSpecs[223]= new productDefaults(1,1,1,3,2,2,1);
braidSpecs[224]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[225]= new productDefaults(2,1,2,2,2,3,2);
braidSpecs[226]= new productDefaults(1,1,1,2,1,2,2);
braidSpecs[227]= new productDefaults(1,1,1,3,1,2,3);
braidSpecs[228]= new productDefaults(1,1,1,3,3,2,3);
braidSpecs[229]= new productDefaults(1,1,1,2,1,3,3);
braidSpecs[230]= new productDefaults(1,1,1,2,1,3,3);
braidSpecs[231]= new productDefaults(1,1,1,2,1,3,3);
braidSpecs[232]= new productDefaults(1,1,1,2,1,3,3);
braidSpecs[233]= new productDefaults(1,1,1,2,1,3,3);
braidSpecs[234]= new productDefaults(1,1,1,2,3,3,3);
braidSpecs[235]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[236]= new productDefaults(1,1,1,3,2,2,3);
braidSpecs[237]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[238]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[239]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[240]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[241]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[242]= new productDefaults(1,1,1,2,1,2,3);
braidSpecs[243]= new productDefaults(1,1,1,2,1,2,3);
braidSpecs[244]= new productDefaults(2,1,2,2,1,3,3);
braidSpecs[245]= new productDefaults(2,2,2,3,3,3,3);
braidSpecs[246]= new productDefaults(1,1,1,2,1,3,2);
braidSpecs[247]= new productDefaults(1,1,1,2,1,3,2);
braidSpecs[248]= new productDefaults(1,1,1,2,1,3,2);
braidSpecs[249]= new productDefaults(1,1,1,2,1,3,2);
braidSpecs[250]= new productDefaults(1,1,1,2,3,3,3);
braidSpecs[251]= new productDefaults(1,1,1,3,3,2,3);
braidSpecs[252]= new productDefaults(1,1,1,1,2,2,2);
braidSpecs[253]= new productDefaults(1,1,1,1,2,2,2);
braidSpecs[254]= new productDefaults(1,1,1,1,2,3,2);
braidSpecs[255]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[256]= new productDefaults(1,1,1,1,1,3,1);
braidSpecs[257]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[258]= new productDefaults(1,1,1,3,3,2,3);
braidSpecs[259]= new productDefaults(2,1,2,3,3,3,3);
braidSpecs[260]= new productDefaults(1,1,1,2,2,3,2);
braidSpecs[261]= new productDefaults(1,1,1,1,1,3,1);
braidSpecs[262]= new productDefaults(3,2,3,2,2,3,2);
braidSpecs[263]= new productDefaults(2,1,2,3,3,3,3);
braidSpecs[264]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[265]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[266]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[267]= new productDefaults(1,1,1,2,1,2,2);
braidSpecs[268]= new productDefaults(1,1,1,2,1,2,2);
braidSpecs[269]= new productDefaults(3,2,3,2,2,3,3);
braidSpecs[270]= new productDefaults(1,1,1,1,1,1,1);
braidSpecs[271]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[272]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[273]= new productDefaults(1,1,1,3,1,3,3);
braidSpecs[274]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[275]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[276]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[277]= new productDefaults(1,1,1,1,1,3,2);
braidSpecs[278]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[279]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[280]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[281]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[282]= new productDefaults(2,1,2,3,2,3,3);
braidSpecs[283]= new productDefaults(1,1,1,3,1,3,3);
braidSpecs[284]= new productDefaults(3,3,3,1,2,3,1);
braidSpecs[285]= new productDefaults(2,1,2,2,3,3,2);
braidSpecs[286]= new productDefaults(1,1,1,1,2,3,1);
braidSpecs[287]= new productDefaults(3,2,3,2,3,3,3);
braidSpecs[288]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[289]= new productDefaults(1,1,1,2,3,3,3);
braidSpecs[290]= new productDefaults(3,3,3,2,3,3,3);
braidSpecs[291]= new productDefaults(3,2,3,2,3,3,3);
braidSpecs[292]= new productDefaults(3,2,3,2,3,3,3);
braidSpecs[293]= new productDefaults(3,2,3,2,3,3,3);
braidSpecs[294]= new productDefaults(3,2,3,2,3,3,3);
braidSpecs[295]= new productDefaults(1,1,1,1,3,3,2);
braidSpecs[296]= new productDefaults(1,1,1,1,3,3,2);
braidSpecs[297]= new productDefaults(1,1,1,3,1,3,3);
braidSpecs[298]= new productDefaults(1,1,1,1,3,2,1);
braidSpecs[299]= new productDefaults(1,1,1,1,2,3,2);
braidSpecs[300]= new productDefaults(2,1,2,1,2,3,2);
braidSpecs[301]= new productDefaults(3,3,3,3,3,3,3);
braidSpecs[302]= new productDefaults(3,1,3,3,3,3,3);
braidSpecs[303]= new productDefaults(3,3,3,2,3,3,3);
braidSpecs[304]= new productDefaults(1,1,1,1,1,3,1);
braidSpecs[305]= new productDefaults(3,3,3,2,3,3,2);
braidSpecs[306]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[307]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[308]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[309]= new productDefaults(1,1,1,2,2,2,3);
braidSpecs[310]= new productDefaults(2,1,2,2,3,3,3);
braidSpecs[311]= new productDefaults(1,1,1,2,3,3,3);
braidSpecs[312]= new productDefaults(1,1,1,1,1,2,1);
braidSpecs[313]= new productDefaults(1,1,1,1,1,3,2);
braidSpecs[314]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[315]= new productDefaults(1,1,1,3,1,3,3);
braidSpecs[316]= new productDefaults(1,1,1,3,2,3,3);
braidSpecs[317]= new productDefaults(2,2,2,3,2,3,3);
braidSpecs[318]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[319]= new productDefaults(1,1,1,3,3,3,3);
braidSpecs[320]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[321]= new productDefaults(1,1,1,2,2,3,3);
braidSpecs[322]= new productDefaults(1,1,1,2,2,3,3);

export const SolutionsOptions = [
  { value: 0, label: "Acetic acid 5% to 20% agitated or aerated", defaults: braidSpecs[0] },
  { value: 1, label: "Acetic acid 50%, 70°F", defaults: braidSpecs[1] },
  { value: 2, label: "Acetic acid 50% to 80%, boiling", defaults: braidSpecs[2] },
  { value: 3, label: "Acetic acid 80%, 70°F", defaults: braidSpecs[3] },
  { value: 4, label: "Acetic acid 100%, boiling", defaults: braidSpecs[4] },
  { value: 5, label: "Acetic acid 100%, 70°F", defaults: braidSpecs[5] },
  { value: 6, label: "Acetic anhydride", defaults: braidSpecs[6] },
  { value: 7, label: "Aceton, boiling", defaults: braidSpecs[7] },
  { value: 8, label: "Acetyl chloride, boiling", defaults: braidSpecs[8] },
  { value: 61, label: "Acetylene concentrated", defaults: braidSpecs[61] },
  { value: 62, label: "Acetylene commercially pure", defaults: braidSpecs[62] },
  { value: 63, label: "Acid salt mixture", defaults: braidSpecs[63] },
  { value: 64, label: "Air", defaults: braidSpecs[64] },
  { value: 65, label: "Aluminium acetate, saturated", defaults: braidSpecs[65] },
  { value: 66, label: "Aluminium chloride 10%, quiescent", defaults: braidSpecs[66] },
  { value: 67, label: "Aluminium chloride 25%, quiescent", defaults: braidSpecs[67] },
  { value: 68, label: "Aluminium hydroxide, saturated", defaults: braidSpecs[68] },
  { value: 69, label: "Aluminium sulfate 5%", defaults: braidSpecs[69] },
  { value: 70, label: "Aluminium sulfate 10%, 70°F", defaults: braidSpecs[70] },
  { value: 71, label: "Aluminium sulfate 10%, boiling", defaults: braidSpecs[71] },
  { value: 72, label: "Aluminium sulfate saturated, 70°F", defaults: braidSpecs[72] },
  { value: 73, label: "Aluminium sulfate saturated, boiling", defaults: braidSpecs[73] },
  { value: 74, label: "Aluminium potassium sulfate (alum) 2% to 1%, 70°F", defaults: braidSpecs[74] },
  { value: 75, label: "Aluminium potassium sulfate (alum) 10%, boiling", defaults: braidSpecs[75] },
  { value: 76, label: "Aluminium potassium sulfate (alum) saturated", defaults: braidSpecs[76] },
  { value: 77, label: "Ammonia (anhydrous) all concentrations", defaults: braidSpecs[77] },
  { value: 78, label: "Ammonia (anhydrous) hot gas", defaults: braidSpecs[78] },
  { value: 79, label: "Ammonia liquor, 70°F", defaults: braidSpecs[79] },
  { value: 80, label: "Ammonia liquor, boiling", defaults: braidSpecs[80] },
  { value: 81, label: "Ammonium bromide", defaults: braidSpecs[81] },
  { value: 82, label: "Ammonium carbonate. 1% and 5%", defaults: braidSpecs[82] },
  { value: 83, label: "Ammonium chloride, 1%", defaults: braidSpecs[83] },
  { value: 84, label: "Ammonium chloride, 10%", defaults: braidSpecs[84] },
  { value: 85, label: "Ammonium chloride, 28%", defaults: braidSpecs[85] },
  { value: 86, label: "Ammonium chloride, 50%", defaults: braidSpecs[86] },
  { value: 87, label: "Ammonium dihydrogen orthophosphate (Ammonium phosphate), 5%", defaults: braidSpecs[87] },
  { value: 88, label: "Ammonium hydrogen carbonate (Ammonium bicarbonate), hot", defaults: braidSpecs[88] },
  { value: 89, label: "Ammonium monophosphate", defaults: braidSpecs[89] },
  { value: 90, label: "Ammonium oxalate, 5%", defaults: braidSpecs[90] },
  { value: 91, label: "Ammonium perchlorate, 10%, boiling", defaults: braidSpecs[91] },
  { value: 92, label: "Ammonium peroxodisulfate (Ammonium persulfate), 5%", defaults: braidSpecs[92] },
  { value: 93, label: "Ammonium solution (Ammonium hydroxide), all concentration", defaults: braidSpecs[93] },
  { value: 94, label: "Ammonium sulfate 1%, aerated or agitated", defaults: braidSpecs[94] },
  { value: 95, label: "Ammonium sulfate 5%, aerated and agitatede", defaults: braidSpecs[95] },
  { value: 96, label: "Ammonium sulfate 10%, saturated", defaults: braidSpecs[96] },
  { value: 97, label: "Ammonium sulfate, 70°F, boiling", defaults: braidSpecs[97] },
  { value: 98, label: "Amyl acetate, concentrate", defaults: braidSpecs[98] },
  { value: 99, label: "Amyl chloride", defaults: braidSpecs[99] },
  { value: 100, label: "Aniline 3%", defaults: braidSpecs[100] },
  { value: 101, label: "Aniline concentrated crude", defaults: braidSpecs[101] },
  { value: 102, label: "Argon (refrigerated liquid)", defaults: braidSpecs[102] },
  { value: 103, label: "Barium carbonate", defaults: braidSpecs[103] },
  { value: 104, label: "Barium chloride, 5%, saturated", defaults: braidSpecs[104] },
  { value: 105, label: "Barium hydroxide, aqueous solution, hot", defaults: braidSpecs[105] },
  { value: 106, label: "Barium nitrate, aqueous solution, hot", defaults: braidSpecs[106] },
  { value: 107, label: "Barium sulfate, (Barytes-blanc fixe)", defaults: braidSpecs[107] },
  { value: 108, label: "Barium sulfide, saturated solution", defaults: braidSpecs[108] },
  { value: 109, label: "Benzene (Benzol) 70°F or hot", defaults: braidSpecs[109] },
  { value: 110, label: "Benzoic acid", defaults: braidSpecs[110] },
  { value: 111, label: "Bitumen", defaults: braidSpecs[111] },
  { value: 112, label: "Butane, -58°F", defaults: braidSpecs[112] },
  { value: 113, label: "Butane, 70°F", defaults: braidSpecs[113] },
  { value: 114, label: "Butyl acid, 5%", defaults: braidSpecs[114] },
  { value: 115, label: "Butyl aqueous solution, dilution of 0.13 oz/gal", defaults: braidSpecs[115] },
  { value: 116, label: "Calcium carbonate", defaults: braidSpecs[116] },
  { value: 117, label: "Calcium chlorate, dilute solution", defaults: braidSpecs[117] },
  { value: 118, label: "Calcium chlorite, dilute or concentrate solution", defaults: braidSpecs[118] },
  { value: 119, label: "Calcium hypochlorite, 2%", defaults: braidSpecs[119] },
  { value: 120, label: "Calcium hydroxide, 10% to 20%", defaults: braidSpecs[120] },
  { value: 121, label: "Calcium sulfate, saturated", defaults: braidSpecs[121] },
  { value: 122, label: "Carbonated water", defaults: braidSpecs[122] },
  { value: 123, label: "Carbonic acid, saturated solution", defaults: braidSpecs[123] },
  { value: 124, label: "Carbon dioxide dry", defaults: braidSpecs[124] },
  { value: 125, label: "Carbon dioxide moist", defaults: braidSpecs[125] },
  { value: 126, label: "Carbone disulfide (Carbon bisulfide)", defaults: braidSpecs[126] },
  { value: 127, label: "Carbon tetrachloride CP", defaults: braidSpecs[127] },
  { value: 128, label: "Carbon tetrachloride dry CP", defaults: braidSpecs[128] },
  { value: 129, label: "Carbon tetrachloride commercial + 1% water", defaults: braidSpecs[129] },
  { value: 130, label: "Cellulose", defaults: braidSpecs[130] },
  { value: 131, label: "Chloracetic acid", defaults: braidSpecs[131] },
  { value: 132, label: "Chlorbenzol, concentrated, pure, dry", defaults: braidSpecs[132] },
  { value: 133, label: "Chlorine gas, dry", defaults: braidSpecs[133] },
  { value: 134, label: "Chlorine gas, moist", defaults: braidSpecs[134] },
  { value: 135, label: "Chlorinated water, saturated", defaults: braidSpecs[135] },
  { value: 136, label: "Chloroform", defaults: braidSpecs[136] },
  { value: 137, label: "Chromium (VI) oxide (Chromic acid) 5% CP", defaults: braidSpecs[137] },
  { value: 138, label: "Chromium (VI) oxide (Chromic acid) 10%", defaults: braidSpecs[138] },
  { value: 139, label: "Chromium plating bath", defaults: braidSpecs[139] },
  { value: 141, label: "Chloroethane (Ethyl chloride)", defaults: braidSpecs[141] },
  { value: 142, label: "Citric acid 5%, still", defaults: braidSpecs[142] },
  { value: 143, label: "Citric acid 15%, still, 70°F", defaults: braidSpecs[143] },
  { value: 144, label: "Citric acid 15%, boiling", defaults: braidSpecs[144] },
  { value: 145, label: "Copper (II) acetate, saturated solution", defaults: braidSpecs[145] },
  { value: 146, label: "Copper (III) carbonate, saturated solution in 50% NH4OH", defaults: braidSpecs[146] },
  { value: 147, label: "Copper (II) cyanide, saturated solution", defaults: braidSpecs[147] },
  { value: 148, label: "Copper (II) nitrate 1% still, agitated and aerated", defaults: braidSpecs[148] },
  { value: 149, label: "Copper (II) nitrate 5% still, agitated and aerated", defaults: braidSpecs[149] },
  { value: 150, label: "Copper (II) nitrate 50% aqueous solution", defaults: braidSpecs[150] },
  { value: 151, label: "Copper (II) sulfate 5% agitated still or aerated", defaults: braidSpecs[151] },
  { value: 152, label: "Copper (II) sulfate saturated solution", defaults: braidSpecs[152] },
  { value: 153, label: "Creosote (coal tar)", defaults: braidSpecs[153] },
  { value: 154, label: "Creosote oil", defaults: braidSpecs[154] },
  { value: 155, label: "Cyanogen gas", defaults: braidSpecs[155] },
  { value: 156, label: "Developing solutions", defaults: braidSpecs[156] },
  { value: 157, label: "Dichloroethane (1,2-Dichloroethylene) dry", defaults: braidSpecs[157] },
  { value: 158, label: "Diethyl ether (Ether)", defaults: braidSpecs[158] },
  { value: 270, label: "Diesel (fuel)", defaults: braidSpecs[270] },
  { value: 140, label: "Dinitrochlorobenzene (1-chloro-2,4-dinitrobenzene) melted and solidified", defaults: braidSpecs[140] },
  { value: 159, label: "Disodium tetraborate (Borax), 5%", defaults: braidSpecs[159] },
  { value: 160, label: "Distillery wort", defaults: braidSpecs[160] },
  { value: 161, label: "Dyewood liquor", defaults: braidSpecs[161] },
  { value: 162, label: "Ethanediol (Ethylene glycol)", defaults: braidSpecs[162] },
  { value: 163, label: "Ethanol (Ethyl alcohol) 70°F and boiling", defaults: braidSpecs[163] },
  { value: 164, label: "Ethyl acetate, concentrated solution", defaults: braidSpecs[164] },
  { value: 165, label: "Ethylene chloride", defaults: braidSpecs[165] },
  { value: 166, label: "Fluorine (gas) moist", defaults: braidSpecs[166] },
  { value: 167, label: "Fluorosilicic (Hydrofluosilicid acid)", defaults: braidSpecs[167] },
  { value: 9, label: "Formaldehyde, 40% solution", defaults: braidSpecs[9] },
  { value: 10, label: "Fuel oil", defaults: braidSpecs[10] },
  { value: 11, label: "Fuel oil containing sulfuric acid", defaults: braidSpecs[11] },
  { value: 12, label: "Furaldehyde, 2-Furaldehyde (Furfural)", defaults: braidSpecs[12] },
  { value: 13, label: "Gelatin", defaults: braidSpecs[13] },
  { value: 14, label: "Glue, dry", defaults: braidSpecs[14] },
  { value: 15, label: "Glue solution, acid", defaults: braidSpecs[15] },
  { value: 16, label: "Glycerol (Glycerine)", defaults: braidSpecs[16] },
  { value: 17, label: "Hydrochloric acid, all concentrations", defaults: braidSpecs[17] },
  { value: 18, label: "Hydrocyanic acid", defaults: braidSpecs[18] },
  { value: 19, label: "Hydrofluoric acid", defaults: braidSpecs[19] },
  { value: 20, label: "Hydrogen peroxide, 70°F", defaults: braidSpecs[20] },
  { value: 21, label: "Hydrogen peroxide, boiling", defaults: braidSpecs[21] },
  { value: 22, label: "Hydrogen sulfide, dry", defaults: braidSpecs[22] },
  { value: 23, label: "Hydrogen sulfide, wet", defaults: braidSpecs[23] },
  { value: 24, label: "Ink", defaults: braidSpecs[24] },
  { value: 25, label: "Iodoform", defaults: braidSpecs[25] },
  { value: 26, label: "Iron (II) chloride (Ferrous chloride) saturated solution", defaults: braidSpecs[26] },
  { value: 27, label: "Iron (III) chloride (Ferric chloride), 1% solution, 70°F", defaults: braidSpecs[27] },
  { value: 28, label: "Iron (III) chloride (Ferric chloride), 1% solution, boiling", defaults: braidSpecs[28] },
  { value: 29, label: "Iron (III) chloride (Ferric chloride), 5% solution agitated, aerated", defaults: braidSpecs[29] },
  { value: 30, label: "Iron (II) hydroxide (Ferric hydroxide) (hydrated iron oxide)", defaults: braidSpecs[30] },
  { value: 31, label: "Iron (III) nitrate (Ferric nitrate) 1% to 5% quiescent or agitated", defaults: braidSpecs[31] },
  { value: 32, label: "Iron (III) nitrate (Ferric nitrate) 1% to 5% aerated", defaults: braidSpecs[32] },
  { value: 33, label: "Iron (II) sulfate (Ferrous sulfate) dilute solution", defaults: braidSpecs[33] },
  { value: 34, label: "Iron (III) sulfate (Ferric sulfate) 1% to 5% quiescent or agitated", defaults: braidSpecs[34] },
  { value: 35, label: "Iron (III) sulfate (Ferric sulfate) 1% to 5% quiescent or aerated", defaults: braidSpecs[35] },
  { value: 36, label: "Iron (III) sulfate (Ferric sulfate) 10%", defaults: braidSpecs[36] },
  { value: 37, label: "Kerosene", defaults: braidSpecs[37] },
  { value: 38, label: "Lactic acid 1%, 70°F", defaults: braidSpecs[38] },
  { value: 39, label: "Lactic acid 1%, boiling", defaults: braidSpecs[39] },
  { value: 40, label: "Lactic acid 5%, 70°F", defaults: braidSpecs[40] },
  { value: 41, label: "Lactic acid 5%, boiling", defaults: braidSpecs[41] },
  { value: 42, label: "Lactic acid 10%, 70°F", defaults: braidSpecs[42] },
  { value: 43, label: "Lactic acid 10%, boiling", defaults: braidSpecs[43] },
  { value: 44, label: "Lactic acid concentrated, 70°F", defaults: braidSpecs[44] },
  { value: 45, label: "Lactic acid concentrated, boiling", defaults: braidSpecs[45] },
  { value: 46, label: "Lead diacetate (Lead acetate) 5%", defaults: braidSpecs[46] },
  { value: 47, label: "Linseed oil", defaults: braidSpecs[47] },
  { value: 48, label: "Magnesium chloride 1% quiescent, 70°F", defaults: braidSpecs[48] },
  { value: 49, label: "Magnesium chloride 1% quiescent, hot", defaults: braidSpecs[49] },
  { value: 50, label: "Magnesium chloride 5% quiescent, 70°F", defaults: braidSpecs[50] },
  { value: 51, label: "Magnesium chloride 5% quiescent, hot", defaults: braidSpecs[51] },
  { value: 52, label: "Magnesium sulfate", defaults: braidSpecs[52] },
  { value: 53, label: "Malice acid", defaults: braidSpecs[53] },
  { value: 54, label: "Mash", defaults: braidSpecs[54] },
  { value: 55, label: "Mercury", defaults: braidSpecs[55] },
  { value: 56, label: "Methane (refrigerated liquid)", defaults: braidSpecs[56] },
  { value: 57, label: "Methanol (Methyl alcohol) boiling", defaults: braidSpecs[57] },
  { value: 58, label: "Mixed acids, 53% H2SO4 + 45% HNO3", defaults: braidSpecs[58] },
  { value: 59, label: "Molasses", defaults: braidSpecs[59] },
  { value: 60, label: "Mustard", defaults: braidSpecs[60] },
  { value: 183, label: "Naphtha crude", defaults: braidSpecs[183] },
  { value: 184, label: "Naphtha pure", defaults: braidSpecs[184] },
  { value: 185, label: "Naphthalene sulfonic acid", defaults: braidSpecs[185] },
  { value: 271, label: "Natural gas", defaults: braidSpecs[271] },
  { value: 186, label: "Nickel chloride solution", defaults: braidSpecs[186] },
  { value: 187, label: "Nickel sulfate", defaults: braidSpecs[187] },
  { value: 188, label: "Nitre cake", defaults: braidSpecs[188] },
  { value: 189, label: "Nitric acid 5%, 50%, 70%, boiling", defaults: braidSpecs[189] },
  { value: 190, label: "Nitric acid 65%, 70°F", defaults: braidSpecs[190] },
  { value: 191, label: "Nitric acid 65%, boiling", defaults: braidSpecs[191] },
  { value: 192, label: "Nitric acid concentrated, 70°F", defaults: braidSpecs[192] },
  { value: 193, label: "Nitric acid concentrated, boiling", defaults: braidSpecs[193] },
  { value: 194, label: "Nitric acid fuming concentrated, 110°F", defaults: braidSpecs[194] },
  { value: 195, label: "Nitric acid fuming concentrated, boiling", defaults: braidSpecs[195] },
  { value: 196, label: "Nitrogen (refrigerated liquid)", defaults: braidSpecs[196] },
  { value: 197, label: "Nitrous acid, 5%", defaults: braidSpecs[197] },
  { value: 198, label: "Oils, crude", defaults: braidSpecs[198] },
  { value: 199, label: "Oils, vegetable, mineral", defaults: braidSpecs[199] },
  { value: 200, label: "Oleic acid", defaults: braidSpecs[200] },
  { value: 201, label: "Orthoboric acid (Boric acid) 5% solution, 70°F", defaults: braidSpecs[201] },
  { value: 202, label: "Orthoboric acid (Boric acid) 5% solution, boiling", defaults: braidSpecs[202] },
  { value: 203, label: "Orthoboric acid (Boric acid) saturated solution, 70°F", defaults: braidSpecs[203] },
  { value: 204, label: "Orthoboric acid (Boric acid) saturated solution, boiling", defaults: braidSpecs[204] },
  { value: 205, label: "Orthophosphoric acid (Phosphoric acid) 1%, 70°F", defaults: braidSpecs[205] },
  { value: 206, label: "Orthophosphoric acid (Phosphoric acid) 1%, boiling", defaults: braidSpecs[206] },
  { value: 207, label: "Orthophosphoric acid (Phosphoric acid) 1% to 3%, 15 psi, 285°F", defaults: braidSpecs[207] },
  { value: 208, label: "Orthophosphoric acid (Phosphoric acid) 5%, quiescent, or agitated", defaults: braidSpecs[208] },
  { value: 209, label: "Orthophosphoric acid (Phosphoric acid) 5%, aerated", defaults: braidSpecs[209] },
  { value: 210, label: "Orthophosphoric acid (Phosphoric acid) 10%, quiescent", defaults: braidSpecs[210] },
  { value: 211, label: "Orthophosphoric acid (Phosphoric acid) 10%, agitated or aerated", defaults: braidSpecs[211] },
  { value: 212, label: "Orthophosphoric acid (Phosphoric acid) 10% to 50%, boiling", defaults: braidSpecs[212] },
  { value: 213, label: "Orthophosphoric acid (Phosphoric acid) 80%, 70°F", defaults: braidSpecs[213] },
  { value: 214, label: "Orthophosphoric acid (Phosphoric acid) 80%, 230°F", defaults: braidSpecs[214] },
  { value: 215, label: "Orthophosphoric acid (Phosphoric acid) 85%, boiling", defaults: braidSpecs[215] },
  { value: 216, label: "Oxalic acid 5%, 10%, 70°F", defaults: braidSpecs[216] },
  { value: 217, label: "Oxalic acid 10%, boiling", defaults: braidSpecs[217] },
  { value: 218, label: "Oxalic acid 25%, 50%, boiling", defaults: braidSpecs[218] },
  { value: 219, label: "Oxygen (refrigerated liquid)", defaults: braidSpecs[219] },
  { value: 220, label: "Paraffin, hot", defaults: braidSpecs[220] },
  { value: 221, label: "Petrol", defaults: braidSpecs[221] },
  { value: 222, label: "Petroleum ether", defaults: braidSpecs[222] },
  { value: 223, label: "Phenol", defaults: braidSpecs[223] },
  { value: 224, label: "Picric acid", defaults: braidSpecs[224] },
  { value: 225, label: "Potassium bromide", defaults: braidSpecs[225] },
  { value: 226, label: "Potassium carbonate 1%, 70°F", defaults: braidSpecs[226] },
  { value: 227, label: "Potassium carbonate 1%, hot", defaults: braidSpecs[227] },
  { value: 228, label: "Potassium chlorade saturated at 212°F", defaults: braidSpecs[228] },
  { value: 229, label: "Potassium chloride 1% quiescent", defaults: braidSpecs[229] },
  { value: 230, label: "Potassium chloride 1% agitated or aerated", defaults: braidSpecs[230] },
  { value: 231, label: "Potassium chloride 5% quiescent", defaults: braidSpecs[231] },
  { value: 232, label: "Potassium chloride 5% agitated or aerated", defaults: braidSpecs[232] },
  { value: 233, label: "Potassium chloride 5%, boiling", defaults: braidSpecs[233] },
  { value: 234, label: "Potassium chromium sulfate 5%", defaults: braidSpecs[234] },
  { value: 235, label: "Potassium chromium dilution of 0.21 oz/gal", defaults: braidSpecs[235] },
  { value: 236, label: "Potassium cyanide", defaults: braidSpecs[236] },
  { value: 237, label: "Potassium dichromate (Potassium bichromate) 25%, 70°F", defaults: braidSpecs[237] },
  { value: 238, label: "Potassium dichromate (Potassium bichromate) 25%, boiling", defaults: braidSpecs[238] },
  { value: 239, label: "Potassium hexacyanoferrate (III) (Potassium ferrocyanide) 5%, 25%, 70°F", defaults: braidSpecs[239] },
  { value: 240, label: "Potassium hexacyanoferrate (III) (Potassium ferrocyanide) 25%, boiling", defaults: braidSpecs[240] },
  { value: 241, label: "Potassium hexacyanoferrate (II) (Potassium ferrocyanide) 5%", defaults: braidSpecs[241] },
  { value: 242, label: "Potassium hydrogen oxalate (Potassium oxalate) 5%", defaults: braidSpecs[242] },
  { value: 243, label: "Potassium hydrogen oxalate (Potassium oxalate) 27%", defaults: braidSpecs[243] },
  { value: 244, label: "Potassium hydrogen oxalate (Potassium oxalate) 50%", defaults: braidSpecs[244] },
  { value: 245, label: "Potassium hypochlorite", defaults: braidSpecs[245] },
  { value: 246, label: "Potassium nitrate 1%, 5% still or agitated", defaults: braidSpecs[246] },
  { value: 247, label: "Potassium nitrate 1%, 5% aerated", defaults: braidSpecs[247] },
  { value: 248, label: "Potassium nitrate 50%, 70°F", defaults: braidSpecs[248] },
  { value: 249, label: "Potassium nitrate 50%, boiling", defaults: braidSpecs[249] },
  { value: 250, label: "Potassium nitrate 50%, molten", defaults: braidSpecs[250] },
  { value: 251, label: "Potassium permanganate, 5%", defaults: braidSpecs[251] },
  { value: 252, label: "Potassium sulfate 1%, 5% or agitated", defaults: braidSpecs[252] },
  { value: 253, label: "Potassium sulfate 1%, 5% aerated, 70°F", defaults: braidSpecs[253] },
  { value: 254, label: "Potassium sulfate hot", defaults: braidSpecs[254] },
  { value: 255, label: "Potassium sulfate (salt)", defaults: braidSpecs[255] },
  { value: 256, label: "Propane -58°F", defaults: braidSpecs[256] },
  { value: 257, label: "Propane 70°F", defaults: braidSpecs[257] },
  { value: 269, label: "Propyl Bromide", defaults: braidSpecs[269] },
  { value: 258, label: "Pyrogallol (Pyrogallic acid)", defaults: braidSpecs[258] },
  { value: 259, label: "Quinine bisulfate, dry", defaults: braidSpecs[259] },
  { value: 260, label: "Quinine sulfate, dry", defaults: braidSpecs[260] },
  { value: 261, label: "Resin", defaults: braidSpecs[261] },
  { value: 262, label: "Sea water", defaults: braidSpecs[262] },
  { value: 263, label: "Silver bromide", defaults: braidSpecs[263] },
  { value: 264, label: "Silver nitrate", defaults: braidSpecs[264] },
  { value: 168, label: "Sodium carbonate, molten", defaults: braidSpecs[168] },
  { value: 169, label: "Sodium chloride 5%, still", defaults: braidSpecs[169] },
  { value: 170, label: "Sodium chloride 20%, aerated", defaults: braidSpecs[170] },
  { value: 171, label: "Sodium chloride saturated, 70°F", defaults: braidSpecs[171] },
  { value: 172, label: "Sodium chloride saturated, boiling", defaults: braidSpecs[172] },
  { value: 173, label: "Sodium cyanide", defaults: braidSpecs[173] },
  { value: 174, label: "Sodium fluoride, 5% solution", defaults: braidSpecs[174] },
  { value: 175, label: "Sodium hydrogen carbonate (Sodium bisulfate) solution", defaults: braidSpecs[175] },
  { value: 176, label: "Sodium hydrogen carbonate (Sodium bisulfate) saturated solution", defaults: braidSpecs[176] },
  { value: 177, label: "Sodium hydroxide", defaults: braidSpecs[177] },
  { value: 178, label: "Sodium hypochlorite", defaults: braidSpecs[178] },
  { value: 179, label: "Sodium nitrate", defaults: braidSpecs[179] },
  { value: 180, label: "Sodium perchlorate, 10%", defaults: braidSpecs[180] },
  { value: 181, label: "Sodium phosphate", defaults: braidSpecs[181] },
  { value: 182, label: "Sodium sulfate 5%", defaults: braidSpecs[182] },
  { value: 265, label: "Soap", defaults: braidSpecs[265] },
  { value: 266, label: "Sodium acetate, moist", defaults: braidSpecs[266] },
  { value: 267, label: "Sodium carbonate 5%, 150°F", defaults: braidSpecs[267] },
  { value: 268, label: "Sodium carbonate 5%, 50%, boiling", defaults: braidSpecs[268] },
  { value: 272, label: "Sodium sulfate 10%", defaults: braidSpecs[272] },
  { value: 273, label: "Sodium thiosulfate saturated solution", defaults: braidSpecs[273] },
  { value: 274, label: "Sodium thiosulfate acid fixing bath (hypo)", defaults: braidSpecs[274] },
  { value: 275, label: "Sodium thiosulfate 25% solution", defaults: braidSpecs[275] },
  { value: 276, label: "Sodium thiosulfite (Sodium hyposulfite)", defaults: braidSpecs[276] },
  { value: 277, label: "Steam", defaults: braidSpecs[277] },
  { value: 278, label: "Stearic acid", defaults: braidSpecs[278] },
  { value: 279, label: "Starch, aqueous solution", defaults: braidSpecs[279] },
  { value: 280, label: "Strontium hydroxide", defaults: braidSpecs[280] },
  { value: 281, label: "Strontium nitrate solution", defaults: braidSpecs[281] },
  { value: 282, label: "Sulfur moist", defaults: braidSpecs[282] },
  { value: 283, label: "Sulfur molten", defaults: braidSpecs[283] },
  { value: 284, label: "Sulfur chloride, dry", defaults: braidSpecs[284] },
  { value: 285, label: "Sulfur dioxide gas, moist", defaults: braidSpecs[285] },
  { value: 286, label: "Sulfur dioxide gas, dry", defaults: braidSpecs[286] },
  { value: 287, label: "Sulfur acid 5%, 10%", defaults: braidSpecs[287] },
  { value: 288, label: "Sulfur acid 50%", defaults: braidSpecs[288] },
  { value: 289, label: "Sulfur acid concentrated, 70°F", defaults: braidSpecs[289] },
  { value: 290, label: "Sulfur acid concentrated, boiling", defaults: braidSpecs[290] },
  { value: 291, label: "Sulfurous acid saturated", defaults: braidSpecs[291] },
  { value: 292, label: "Sulfurous acid saturated, 60 psi pressure", defaults: braidSpecs[292] },
  { value: 293, label: "Sulfurous acid saturated, 120 psi pressure", defaults: braidSpecs[293] },
  { value: 294, label: "Sulfurous acid saturated, 150 psi pressure", defaults: braidSpecs[294] },
  { value: 295, label: "Tannic acid, 70°F", defaults: braidSpecs[295] },
  { value: 296, label: "Tannic acid, 150°F", defaults: braidSpecs[296] },
  { value: 297, label: "Tanning liquor", defaults: braidSpecs[297] },
  { value: 298, label: "Tar", defaults: braidSpecs[298] },
  { value: 299, label: "Tartaric acid 10%, 70°F", defaults: braidSpecs[299] },
  { value: 300, label: "Tartaric acid 10%, 50%, boiling", defaults: braidSpecs[300] },
  { value: 301, label: "Tin (VI) chloride (Stannous chloride) (dilution of 0.16 oz/gal)", defaults: braidSpecs[301] },
  { value: 302, label: "Tin (II) chloride (Stannous chloride) saturated", defaults: braidSpecs[302] },
  { value: 303, label: "Trichloroacetic acid", defaults: braidSpecs[303] },
  { value: 304, label: "Trichloroethylene, dry", defaults: braidSpecs[304] },
  { value: 305, label: "Trichloroethylene, moist", defaults: braidSpecs[305] },
  { value: 306, label: "Trichloroethylene, 3,3,5-Trihydroxybenzoic acid (Gallic acid) 5%", defaults: braidSpecs[306] },
  { value: 307, label: "Trichloroethylene, 3,3,5-Trihydroxybenzoic acid (Gallic acid) saturated", defaults: braidSpecs[307] },
  { value: 308, label: "Varnish", defaults: braidSpecs[308] },
  { value: 309, label: "Vegetable juices", defaults: braidSpecs[309] },
  { value: 310, label: "Vinegar fumes", defaults: braidSpecs[310] },
  { value: 311, label: "Vinegar, still, agitated or aerated", defaults: braidSpecs[311] },
  { value: 312, label: "Water, potable", defaults: braidSpecs[312] },
  { value: 313, label: "Whisky", defaults: braidSpecs[313] },
  { value: 314, label: "Wine, all phases of processing and storing", defaults: braidSpecs[314] },
  { value: 315, label: "Yeast", defaults: braidSpecs[315] },
  { value: 316, label: "Zinc chloride 5%, still", defaults: braidSpecs[316] },
  { value: 317, label: "Zinc chloride 70°F, boiling", defaults: braidSpecs[317] },
  { value: 318, label: "Zinc cyanide, moist", defaults: braidSpecs[318] },
  { value: 319, label: "Zinc nitrate, solution", defaults: braidSpecs[319] },
  { value: 320, label: "Zinc sulfate 4%", defaults: braidSpecs[320] },
  { value: 321, label: "Zinc sulfate 25%", defaults: braidSpecs[321] },
  { value: 322, label: "Zinc sulfate saturated", defaults: braidSpecs[322] },
];